import {createUseStyles} from "react-jss";
import {breakpoints} from "../../../../constants/breakpoints";
import {colors} from "../../../../constants/colors";

const styles = createUseStyles({
  emailAddressesContainer: {
    position: "relative",
    padding: "12px 10px 0px",
    width:"352px",
    height:"128px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
    },
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      position: "relative",
    },
    display: "flex",
    flexDirection:"row",
    flexWrap:"wrap",
    alignContent:"flex-start",
    overflow:"auto",
    borderRadius: "8px",
    border: `1px solid ${colors.darkGrey}`,
    "&:focus-within": {
      border: "1px solid " + colors.black,
    }
  },
  errorBorder: {
    border: `1px solid ${colors.mediumRed}`,
  },
  errorTagItem :{
    height: "20px",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    border:"none",
    "&:focus" : {
      outline: "none !important",
      border:"none",
    },
    backgroundColor: colors.lightRed,
    color:colors.darkRed
  },
  errorTagItemContainer: {
    width: "auto",
    border:"none",
    "&:focus" : {
      outline: "none !important",
      border:"none",
    },
    "& input:focus" : {
      backgroundColor: colors.white
    },
    "&:focus-within" : {
      backgroundColor: colors.white
    },
    "& input:focus + button" : {
      display: "none"
    },
    backgroundColor: colors.lightRed,
    color:colors.darkRed,
    fontSize: "14px",
    fontWeight:"500",
    borderRadius: "16px",
    height: "28px",
    padding: "4px 12px",
    alignItems: "center",
    margin: "0px 4px 8px 4px",
    display: "flex"
  },
  tagItem :{
    height: "20px",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "20px",
    border:"none",
    "&:focus" : {
      outline: "none !important",
      border:"none",
    },
    backgroundColor: colors.veryLightGrey,
    color:colors.grey
  },
  tagItemContainer: {
    width: "auto",
    border:"none",
    "&:focus" : {
      outline: "none !important",
      border:"none",
    },
    "& input:focus" : {
      backgroundColor: colors.white
    },
    "&:focus-within" : {
      backgroundColor: colors.white
    },
    "& input:focus + button" : {
      display: "none"
    },
    backgroundColor: colors.veryLightGrey,
    fontSize: "14px",
    fontWeight:"500",
    borderRadius: "16px",
    height: "28px",
    padding: "4px 12px",
    alignItems: "center",
    color:colors.grey,
    margin: "0px 4px 8px 4px",
    display: "flex"
  },
  closeBtn:{
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    justifyContent: "center",
    border:"none",
    borderRadius:"8px",
    padding: 0,
    backgroundColor: "transparent",
    "&:focus-visible": {
      outline: 0
    }
  },
  closeIcon:{
    marginLeft: "2px",
    width: "14px",
    height: "14px"
  },
  errorCloseIcon: {
    marginLeft: "2px",
    width: "14px",
    height: "14px",
    "& path": {
      stroke: colors.darkRed
    }
  },
  inputEmail:{
    flex: "auto",
    resize: "none",
    height: "27px",
    padding: "0px 4px",
    border:"none",
    "&:focus" : {
      outline: "none !important",
      border:"none",
    },
    "&:hover" : {
      border:"none",
    },
    fontSize: "16px",
    fontWeight:"400",
    lineHeight: "24px",
    color: colors.inactiveGrey,
  },
  placeholderSpan: {
    position: "absolute",
    fontSize: "16px",
    fontWeight:"400",
    lineHeight: "24px",
    color: colors.inactiveGrey,
    marginLeft: "4px",
    marginTop: "2px",
    cursor: "text"
  },
  error:{
    color: colors.red,
    fontSize: "14px",
    fontWeight:"400",
    textAlign:"left",
  },
  span: {
    position: "absolute",
    opacity: "0",
    zIndex: "-100",
    whiteSpace: "pre"
  },
  spanBox: {
    height: "77px",
    width: "100%",
  }
});

export default styles;